<template>


  <div class="wrapper">

    <v-sidebar activeNavItem="asset"></v-sidebar>

    <div class="main-panel">

      <v-navbar v-bind:title="'Assets'" v-bind:path="'/asset'"></v-navbar>

      <form @submit.prevent="beforeSubmit">
        <div class="content">
            <div class="container-fluid">
              <div class="row">
                <TractorForm v-if="type === 'tractor'" ref="form" v-bind:title="'Tractor Details'" readonly="true"></TractorForm>
                <TrailerForm v-if="type === 'trailer'" ref="form" v-bind:title="'Trailer Details'" readonly="true"></TrailerForm>
              </div>
              <div class="row">
                <div class="col-12 text-right">

                  <p v-for="error in validationErrors" class="help is-danger">{{ error.msg }}</p>


                  <button class="btn btn-success btn-wd" v-on:click="cancel()"><i class="fa fa-chevron-left"></i> Back</button>
                </div>
              </div>
            </div>
        </div>
      </form>

      <v-footer></v-footer>

    </div>

  </div>


</template>

<script>
import Vue from 'vue'

import router from '../../router'
import apiService from '../../services/api.service'

import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'
import TractorForm from './TractorForm'
import TrailerForm from './TrailerForm'

export default {
  name: 'TractorDetails',
  components: {
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer,
    'TractorForm': TractorForm,
    'TrailerForm': TrailerForm,
  },
  data: () => ({
    loadData: null,
    validationErrors: [],
    type: null
  }),
  async mounted () {
    this.type = this.$route.params.type;
    if(this.type !== "tractor" && this.type !== "trailer") {
      this.toList();
      return;
    }

    try {
      const resp = await apiService.get('/kong/api/v1/asset/id/' + this.$route.params.id);
      const body = resp.data;
      this.$refs.form.loadData(body.Result);
    } catch (error) {
      Vue.toasted.error(error.message, { duration: 3500 });
      this.cancel();
      return;
    }
  }, // end mounted
  methods: {
    cancel: () => router.push("/asset/view"),
    addErrors: function(srcErrors) {
      if(srcErrors && srcErrors.count() > 0) this.validationErrors = this.validationErrors.concat(srcErrors.items);
    },
  }
}
</script>



// WEBPACK FOOTER //
// AssetDetails.vue?71a7a473